import CustomersCreateQuickForm from './CustomersCreateQuickForm';

export default CustomersCreateQuickForm;
